import { CSSProperties } from "react";

export const useStyles = () => {
  const styles: Record<string, CSSProperties> = {
    text: {
      textAlign: "center",
    },
  };

  return styles;
};
